"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinStay = void 0;
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const merlin_input_stepper_1 = require("@travelnest/merlin.input-stepper");
const index_1 = require("../../../../index");
const react_1 = __importDefault(require("react"));
const fullStory_1 = require("../../../../util/fullStory");
const Heading_1 = require("../../heading/Heading");
const Label_1 = require("../../input/label/Label");
const Spacer_1 = require("../../spacer/Spacer");
const MinStay = ({ defaults, setDefaults }) => {
    const { propertyId } = react_1.default.useContext(index_1.AppContext);
    react_1.default.useEffect(() => {
        (0, fullStory_1.sendCustomFullStoryEvent)('smart_pricing_min_stay_modal_viewed', { property_id: propertyId });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Heading_1.HeadingSmall, null, "Minimum stay"),
        react_1.default.createElement(Spacer_1.Spacer, { spacing: "small" }),
        react_1.default.createElement(Label_1.ParagraphLabel, { htmlFor: "minimum-nights-stay" }, "What is the shortest duration a guest can stay for?"),
        react_1.default.createElement(Spacer_1.Spacer, null),
        react_1.default.createElement(merlin_input_stepper_1.InputStepper, { id: "minimum-nights-stay", onClick: (nightStay) => setDefaults(Object.assign(Object.assign({}, defaults), { min_stay: nightStay })), minValue: 1, maxValue: 7, value: defaults.min_stay, valueFormatter: (n) => `${n} night${n === 1 ? '' : 's'}` }),
        react_1.default.createElement(Spacer_1.Spacer, null),
        react_1.default.createElement(merlin_info_panels_1.DidYouKnow, { id: "min-stay-info-panel", colour: "purple", text: "A minimum stay of 1 or 2 nights will increase your chances of getting booked." })));
};
exports.MinStay = MinStay;
//# sourceMappingURL=MinStay.js.map